// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_j5-0";
export var optionCard = "_j5-1";